import PageHeader from "@/components/site/PageHeader";
import RepForm from "@/components/forms/RepForm";

export default function ForRepsPage() {
    return (
        <div data-testid="for-reps-page">
            <PageHeader
                eyebrow="Onboarding"
                title="Join the 1099er Network."
                testId="for-reps-header"
            />
            <RepForm />
        </div>
    );
}
